(() => {
  const carouselSelector = '.jdgm-widget.jdgm-cards-carousel';
  const widgetSelector = '.jdgm-widget.jdgm-review-widget';
  const linkClass = 'ea-judgeme-write-review';
  const wrapperClass = 'ea-judgeme-write-review-wrap';
  const shortCarouselClass = 'ea-judgeme-short-carousel';

  function tidyShortCarousel(carousel) {
    const track = carousel.querySelector('.jdgm-videos-container');
    if (!track) return;

    const genuineCards = [...track.querySelectorAll('.jdgm-card')].filter(
      (card) => !card.dataset.cloneType &&
        !card.classList.contains('jdgm-clone-before') &&
        !card.classList.contains('jdgm-clone-after')
    );

    if (!genuineCards.length || genuineCards.length >= 4) {
      carousel.classList.remove(shortCarouselClass);
      carousel.style.removeProperty('--ea-review-count');
      return;
    }

    carousel.classList.add(shortCarouselClass);
    carousel.style.setProperty('--ea-review-count', genuineCards.length);

    if (window.matchMedia('(min-width: 1150px)').matches) {
      const content = carousel.querySelector('.jdgm-content');
      const availableTrackWidth = Math.max((content?.clientWidth || 0) - 104, 0);
      const cardWidth = Math.max((availableTrackWidth - 60) / 4, 0);

      if (cardWidth) {
        carousel.style.setProperty('--ea-short-card-width', `${cardWidth}px`);
      }
    }

  }

  function findReviewTrigger() {
    const widget = document.querySelector(widgetSelector);
    if (!widget) return null;

    return (
      widget.querySelector('.jm-action-buttons__button') ||
      [...widget.querySelectorAll('button, a')].find((element) =>
        /write\s+a\s+review/i.test(element.textContent || '')
      ) ||
      null
    );
  }

  function waitForReviewTrigger(timeout = 5000) {
    const existingTrigger = findReviewTrigger();
    if (existingTrigger) return Promise.resolve(existingTrigger);

    return new Promise((resolve) => {
      const observer = new MutationObserver(() => {
        const trigger = findReviewTrigger();
        if (!trigger) return;

        window.clearTimeout(timer);
        observer.disconnect();
        resolve(trigger);
      });

      const timer = window.setTimeout(() => {
        observer.disconnect();
        resolve(null);
      }, timeout);

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    });
  }

  function initialise() {
    const reviewWidget = document.querySelector(widgetSelector);
    if (reviewWidget) reviewWidget.classList.add('ea-judgeme-form-source');

    document.querySelectorAll(carouselSelector).forEach((carousel) => {
      tidyShortCarousel(carousel);

      const nextElement = carousel.nextElementSibling;
      if (nextElement?.classList.contains(wrapperClass)) return;

      const wrapper = document.createElement('div');
      wrapper.className = wrapperClass;

      const link = document.createElement('button');
      link.type = 'button';
      link.className = linkClass;
      link.textContent = 'Write a review';

      link.addEventListener('click', async () => {
        const trigger = await waitForReviewTrigger();
        if (trigger) trigger.click();
      });

      wrapper.appendChild(link);
      carousel.insertAdjacentElement('afterend', wrapper);
    });
  }

  initialise();

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(initialise, 150);
  });

  new MutationObserver(initialise).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
